import { type Dispatch, type FC, type SetStateAction } from 'react'

import { Checkbox } from 'base-ui'

import { OrderImageItem } from '../../../../order'
import { type SubOrderProductListProps } from '../../../hooks/useDirectContactFormOrderSelection'

interface ItemProps {
  hashedToken?: string
  isERx?: boolean
  itemName: string
  itemQuantity?: string
  pzn?: string
  selectedSubOrderItems: SubOrderProductListProps[]
  setSelectedSubOrderItems: Dispatch<SetStateAction<SubOrderProductListProps[]>>
  subOrderId?: string
  thumbnailURL?: string
}

export const DirectContactFormOrderItemCheckboxSelection: FC<ItemProps> = ({
  hashedToken,
  isERx,
  itemName,
  itemQuantity,
  pzn,
  selectedSubOrderItems,
  setSelectedSubOrderItems,
  subOrderId,
  thumbnailURL,
}) => {
  const hasItem = [...selectedSubOrderItems].some((product) => {
    if (isERx) {
      return product.hashedToken === hashedToken
    }

    return product.pzn === pzn && product.subOrderId === subOrderId
  })

  const handleButtonClick = (): void => {
    if (hasItem) {
      setSelectedSubOrderItems((prevState) => {
        const updatedSubOrderProducts = prevState.filter((product) => {
          if (
            (isERx && product.hashedToken === hashedToken) ||
            (!isERx && product.pzn === pzn && product.subOrderId === subOrderId)
          ) {
            return false
          }

          return true
        })

        return updatedSubOrderProducts
      })
    } else {
      setSelectedSubOrderItems((prevState) => {
        const selectedSubOrderProduct =
          isERx && hashedToken
            ? { hashedToken, itemName, pzn, subOrderId }
            : { itemName, pzn, subOrderId }

        return [...prevState, selectedSubOrderProduct]
      })
    }
  }

  return (
    <button
      className="my-1 flex cursor-pointer items-center gap-4 rounded-2xl bg-light-primary-low p-4 text-dark-primary-max shadow-m transition-all hover:bg-light-brand-medium hover:shadow-xl"
      onClick={handleButtonClick}
      type="button"
    >
      <Checkbox
        aria-labelledby="checkbox-label"
        checked={hasItem}
        className="shrink-0 cursor-pointer"
        data-qa-id={`direct-contact-checkbox-form-item-${itemName}`}
        readOnly
      />
      <ul className="flex gap-2">
        <OrderImageItem
          alt={itemName}
          data-qa-id={`direct-contact-form-order-item-${itemName}`}
          isERx={isERx}
          src={thumbnailURL}
        />
      </ul>
      <div className="flex flex-col items-start text-dark-primary-max">
        <span className="text-start">{itemName}</span>
        <span>{itemQuantity}</span>
      </div>
    </button>
  )
}
